import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function CreateDocument() {
  const { modals } = useFileManagerContext();

  return (
    <Button className="files-sq-button create-document pointer grid-view-style" onClick={() => modals.setShowCreateDocumentModal(true)}>
      <Tooltip content="Create Document" position="top" target=".create-document" showDelay={500} />
      <i className="icon-doc fa-lg"></i>
    </Button>
  );
}

export default CreateDocument;
